import moment from 'moment';

// timestamp diagnosisTime 'YYYY/MM/DD' 형식으로 전환
export const calculationTimeStamp = (timestamp: number) => {
    let roundedTime;

    const time = moment(timestamp);
    const minutes = time.minutes();

    roundedTime = minutes === 30 ? time.startOf('hour').add(30, 'minutes') : time.startOf('hour');

    // const formattedTimestamp = roundedTime.minutes() === 0 ? roundedTime.format('YYYY/MM/DD A h시') : roundedTime.format('YYYY/MM/DD A h시 m분');
    const formattedTimestamp = roundedTime.minutes() === 0 ? roundedTime.format('YYYY/MM/DD A h:00') : roundedTime.format('YYYY/MM/DD A h:30');

    return formattedTimestamp;
};

// export const formattedTime = (time: string) => {
//     let date = moment(time, 'YYYYMMDDHHmm');

//     let formattedDate = date.minutes() === 30 ? date.format('YYYY/MM/DD A h시 30분') : date.format('YYYY/MM/DD A h시');
//     return formattedDate;
// };
export const formattedTime = (time: string) => {
    let date = moment(time, 'YYYYMMDDHHmm');

    let formattedDate = date.minutes() === 30 ? date.format('YYYY/MM/DD A h:30') : date.format('YYYY/MM/DD A h:00');
    return formattedDate;
};

export const ViewDianosisformattedTime = (time: string) => {
    let date = moment(time, 'YYYYMMDDHHmm');

    let formattedDate = date.minutes() === 30 ? date.format('YYYY/MM/DD A h:30') : date.format('YYYY/MM/DD A h시');
    return formattedDate;
};

export const formattedTimeNotFilter = (time: string) => {
    let date = moment(time, 'YYYYMMDDHHmm');

    const formattedDate = date.format('YYYY/MM/DD A h:mm');
    return formattedDate;
};

export const formatTimestamp = (timestamp: number) => {
    return moment(timestamp).format('YYYY/MM/DD A h:mm'); // 'A'는 오전/오후, 'h:mm'은 12시간제 시간
};

// 0000/00/00(일) 오전 00:00
export const formatDateTime = (dateTimeStr: string) => {
    return moment(dateTimeStr, 'YYYYMMDDHHmm').format('YYYY/MM/DD(ddd) A h:mm');
};

// YYYY년 M월 D일 d요일
export const formatDateDay = (dateTimeStr: string) => {
    return moment(dateTimeStr, 'YYYYMMDDHHmm').format('YYYY년 M월 D일 dddd');
};

/**
 * YYYYMMDDHHMM 형식의 문자열을 한글 포맷으로 변환
 * @param dateString - 'YYYYMMDDHHMM' 형식의 문자열 (예: "202504181430")
 * @returns 2025년 04월 18일 (목) 오후 2:30
 */
export const formatDateString = (dateString: string): string => {
    const date = moment(dateString, 'YYYYMMDDHHmm');

    // 유효하지 않은 날짜인 경우 처리
    if (!date.isValid()) return '날짜 형식이 올바르지 않습니다';

    // 요일 배열 (moment의 day()는 0=일요일, 6=토요일 반환)
    const daysOfWeek = ['일', '월', '화', '수', '목', '금', '토'];
    const dayOfWeek = daysOfWeek[date.day()];

    // YYYY년 MM월 DD일 형식
    const dateFormat = date.format('YYYY년 MM월 DD일');

    // 오전/오후 및 시간:분 형식
    const timeFormat = date.format('A h:mm').replace('AM', '오전').replace('PM', '오후');

    return `${dateFormat} (${dayOfWeek}) ${timeFormat}`;
};

/**
 * YYYYMMDDHHMM 형식의 문자열에서 날짜와 시간을 분리하여 반환
 * @param dateTimeString - YYYYMMDDHHMM 형식의 문자열 (예: "202504181430")
 * @returns {date: "4월 18일", time: "오후 2:30"} 형식의 객체
 */
export const splitDateTime = (dateTimeString: string): { date: string; time: string } => {
    const date = moment(dateTimeString, 'YYYYMMDDHHmm');

    // 유효하지 않은 날짜인 경우 처리
    if (!date.isValid()) {
        return {
            date: '날짜 형식 오류',
            time: '시간 형식 오류',
        };
    }

    // 날짜 부분: "M월 D일" 형식
    const dateFormat = date.format('M월 D일');

    // 시간 부분: "오전/오후 h:mm" 형식
    const timeFormat = date.format('A h:mm').replace('AM', '오전').replace('PM', '오후');

    return {
        date: dateFormat,
        time: timeFormat,
    };
};

// 날짜 문자열("YYYY/MM/DD")을 오늘 날짜와 비교해서, 오늘보다 과거면 오늘 날짜로 반환
export const getValidDateString = (dateStr: string): string => {
    // 입력값이 유효하지 않으면 오늘 날짜 반환
    if (!moment(dateStr, 'YYYY/MM/DD', true).isValid()) {
        return moment().format('YYYY/MM/DD');
    }

    const inputTimestamp = moment(dateStr, 'YYYY/MM/DD').valueOf();
    const todayTimestamp = moment().startOf('day').valueOf();

    // 입력 날짜가 오늘보다 과거면 오늘 날짜 반환, 아니면 원래 값 반환
    if (inputTimestamp < todayTimestamp) {
        return moment().format('YYYY/MM/DD');
    }
    return dateStr;
};

/**
 * 주어진 날짜 문자열을 원하는 포맷으로 변환
 * @param dateString - 원본 날짜 (YYYYMMDDHHmm 또는 timestamp)
 * @param inputFormat - 입력 날짜의 형식 (기본: YYYYMMDDHHmm)
 * @param outputFormat - 원하는 출력 포맷 (moment.js 포맷)
 * @returns 변환된 문자열 (유효하지 않으면 '날짜 형식 오류')
 */
export function formatDateFlexible(dateString: string | number, outputFormat: string, inputFormat: string = 'YYYYMMDDHHmm'): string {
    const date =
        typeof dateString === 'number'
            ? moment(dateString) // timestamp 지원
            : moment(dateString, inputFormat);

    if (!date.isValid()) return '날짜 형식 오류';

    return date.format(outputFormat);
}
